import React from 'react';

import { DesignCard } from '@/modules/corporate/components/Design/enums';

import { useDesignContext } from '../../context/Design';
import Cover from '../Cover';

const SidebarOverlay: React.FC = () => {
  const { overlayContent } = useDesignContext();

  switch (overlayContent.type) {
    case DesignCard.Cover: {
      return <Cover />;
    }
    default:
      return null;
  }
};

export default SidebarOverlay;
